<template>
    <div class="d-flex align-items-center gap-8">
        <!-- Просмотр -->
        <template v-if="!editing">
            <div class="d-flex flex-column">
                <span>{{ display }}</span>
                <small v-if="overdue" class="text-danger">(просрочено)</small>
            </div>
            <button
                v-if="canEdit"
                type="button"
                class="btn btn-sm btn-link p-0 ms-2"
                @click="startEdit"
                aria-label="Редактировать дату"
                title="Редактировать дату"
            >
                <img
                    src="/images/icons/edit.svg"
                    alt="edit"
                />
            </button>
        </template>

        <!-- Редактирование -->
        <form v-else :action="action" method="post" class="d-flex flex-column align-items-center gap-8">
            <input type="hidden" name="_token" :value="csrf">
            <input type="hidden" name="_method" value="PATCH">
            <input
                type="date"
                name="deadline"
                class="form-control-1 mb-0 rounded-0"
                :value="currentValue"
                :min="min"
                :max="max"
                required
                @input="onInput"
            />
            <div class="d-flex gap-2 mt-1">
                <button type="submit" class="btn btn-sm btn-outline-success">
                    {{ tSave }}
                </button>
                <button type="button" class="btn btn-sm btn-outline-secondary" @click="cancelEdit">
                    {{ tCancel }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'DeadlineEditor',
    props: {
        value: {type: String, required: true},
        display: {type: String, required: true},
        min: {type: String, required: true},
        max: {type: String, required: true},
        action: {type: String, required: true},
        canEdit: {type: Boolean, default: false},
        overdue: {type: Boolean, default: false},
        tSave: {type: String, default: 'Сохранить'},
        tCancel: {type: String, default: 'Отмена'},
    },
    data() {
        return {
            editing: false,
            currentValue: this.value,
            csrf: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '',
        };
    },
    watch: {
        value(v) {
            if (!this.editing) this.currentValue = v;
        },
    },
    methods: {
        startEdit() {
            this.currentValue = this.value;
            this.editing = true;
        },
        cancelEdit() {
            this.editing = false;
        },
        onInput(e) {
            this.currentValue = e.target.value;
        },
    },
};
</script>
